module.exports = __webpack_public_path__ + "static/laser1-ae77294291c7036c80c73968e63225ff.jpg";